import { useState } from "react";
import { FaX, FaLink, FaWhatsapp } from "react-icons/fa6";
import { FaXTwitter, FaFacebook, FaLinkedin } from "react-icons/fa6";
import { FaFacebookMessenger } from "react-icons/fa";
import "./ShareModal.css";

const ShareModal = ({ isOpen, onClose, business, url }) => {
  const [showMore, setShowMore] = useState(false);

  if (!isOpen) return null;

  const businessName = business?.name || "";
  const businessSlug = business?.urlSlug || "";
  const businessLogo = business?.logo;
  const businessBio = business?.linktreeConfig?.bio || "";

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      // You could show a toast here
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  // Get the absolute URL that will be shared
  const getShareableUrl = () => {
    let absoluteUrl = url;
    if (
      !absoluteUrl.startsWith("http://") &&
      !absoluteUrl.startsWith("https://")
    ) {
      absoluteUrl = `https://${absoluteUrl}`;
    }
    return absoluteUrl;
  };

  const shareableUrl = getShareableUrl();

  // Build share text with title, description, and URL
  const buildShareText = () => {
    let text = businessName;
    if (businessBio) {
      text += `\n\n${businessBio}`;
    }
    text += `\n\n${shareableUrl}`;
    return text;
  };

  const handleShare = (platform) => {
    const shareText = buildShareText();
    const encodedUrl = encodeURIComponent(shareableUrl);
    const encodedText = encodeURIComponent(shareText);
    let shareUrl = "";

    switch (platform) {
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${encodedText}`;
        break;
      case "twitter":
        const twitterText = businessBio
          ? `${businessName}\n\n${businessBio}\n\n${shareableUrl}`
          : `${businessName} ${shareableUrl}`;
        shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodeURIComponent(
          twitterText
        )}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
        break;
      case "messenger":
        handleCopyLink();
        return;
      default:
        return;
    }

    if (shareUrl) {
      window.open(shareUrl, "_blank", "noopener,noreferrer");
    }
  };

  const handleRegister = () => {
    window.open("https://mennu.mx", "_blank", "noopener,noreferrer");
  };

  const handleDiscover = () => {
    window.open("https://mennu.mx", "_blank", "noopener,noreferrer");
  };

  return (
    <div className="share-modal-overlay" onClick={onClose}>
      <div className="share-modal" onClick={(e) => e.stopPropagation()}>
        <div className="share-modal-header">
          <h2 className="share-modal-title">Compartir enlace</h2>
          <button
            className="share-modal-close"
            onClick={onClose}
            aria-label="Cerrar"
          >
            <FaX />
          </button>
        </div>

        <div className="link-preview-preview-card">
          <div className="link-preview-card-content">
            <div className="link-preview-title">{businessName}</div>
            <div className="link-preview-url-container">
              <span className="link-preview-url">{shareableUrl}</span>
              <FaLink className="link-preview-url-icon" />
            </div>
            {showMore && businessBio && (
              <div className="link-preview-description">{businessBio}</div>
            )}
            {businessBio && (
              <button
                className="link-preview-more-btn"
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? "Menos" : "Más"}
              </button>
            )}
          </div>
        </div>

        <div className="link-preview-modal-options">
          <div className="share-option" onClick={handleCopyLink}>
            <div className="share-option-icon share-option-icon--copy">
              <FaLink />
            </div>
            <span className="share-option-label">Copiar enlace</span>
          </div>

          <div className="share-option" onClick={() => handleShare("twitter")}>
            <div className="share-option-icon share-option-icon--twitter">
              <FaXTwitter />
            </div>
            <span className="share-option-label">X</span>
          </div>

          <div className="share-option" onClick={() => handleShare("facebook")}>
            <div className="share-option-icon share-option-icon--facebook">
              <FaFacebook />
            </div>
            <span className="share-option-label">Facebook</span>
          </div>

          <div className="share-option" onClick={() => handleShare("whatsapp")}>
            <div className="share-option-icon share-option-icon--whatsapp">
              <FaWhatsapp />
            </div>
            <span className="share-option-label">WhatsApp</span>
          </div>

          <div className="share-option" onClick={() => handleShare("linkedin")}>
            <div className="share-option-icon share-option-icon--linkedin">
              <FaLinkedin />
            </div>
            <span className="share-option-label">LinkedIn</span>
          </div>

          <div
            className="share-option"
            onClick={() => handleShare("messenger")}
          >
            <div className="share-option-icon share-option-icon--messenger">
              <FaFacebookMessenger />
            </div>
            <span className="share-option-label">Messenger</span>
          </div>
        </div>

        <div className="link-preview-modal-cta">
          <div className="link-preview-modal-cta-header">
            {businessLogo && (
              <div className="link-preview-modal-cta-logo-wrapper">
                <img
                  src={businessLogo}
                  alt={businessName || "Negocio"}
                  className="link-preview-modal-cta-logo"
                />
              </div>
            )}
            <h3 className="link-preview-modal-cta-title">
              Únete a {businessName || businessSlug || "mennu"} en Mennu.mx
            </h3>
          </div>
          <p className="link-preview-modal-cta-description">
            Obtén tu propio Mennu.mx gratis. El único enlace en bio en el que
            confían más de 70 millones de personas.
          </p>
          <div className="link-preview-modal-cta-buttons">
            <button
              className="link-preview-modal-btn link-preview-modal-btn--primary"
              onClick={handleRegister}
            >
              Regístrate gratis
            </button>
            <button
              className="link-preview-modal-btn link-preview-modal-btn--secondary"
              onClick={handleDiscover}
            >
              Descubre más
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
